import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setTaskOptions } from '../store/options.actions'

export function* getTaskOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const taskOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getTaskOptions])
    const { entity } = taskOptionsResponse
    if (entity) yield put(setTaskOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getTaskOptions() error: ${e}`))
  }
}

export function* getTaskOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getTaskOptions)
}
